<div class="login-container">
  <div class="login-card card">
    <div class="public-forms-header mb-3">
      <a href="https://www.brandshelter.com">
        <img alt="Logo" [src]="logoUrl()">
      </a>
      <a class="text-white" [routerLink]="['/login']" i18n="password-reset|Back to login link">Back to login</a>
    </div>

    <alert type="warning" [hidden]="!errorMessage">{{errorMessage}}</alert>
    <alert type="success" [hidden]="!successMessage">{{successMessage}}</alert>

    <form [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="mb-3">
        <label class="form-label" i18n="password-reset|Email field label">Email</label>
        <input type="email" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && form.get('email')?.errors }" />
        <div class="help" i18n="password-reset|Email help text">Enter the email address associated with your account.</div>
        @if (submitted && form.get('email')?.errors) {
          <div>
            @if (form.get('email')?.errors?.['required']) {
              <div i18n="password-reset|Email required error">Email is required</div>
            }
            @if (form.get('email')?.errors?.['email']) {
              <div i18n="password-reset|Email format error">Please enter a valid email address</div>
            }
          </div>
        }
      </div>
      <div>
        <button [disabled]="submitted && !form.valid" class="btn btn-bs-primary" i18n="password-reset|Reset password button">
          Reset Password
        </button>
      </div>
    </form>
  </div>

  <app-footer-links></app-footer-links>
</div>